import { resolveEnvironment } from '../../utils';
export function useAccountLinks(_ref) {
  var email = _ref.email,
    identityEnvironment = _ref.identityEnvironment,
    application = _ref.application,
    continueUrl = _ref.continueUrl,
    logOutContinueUrl = _ref.logOutContinueUrl,
    isLoggedOut = _ref.isLoggedOut,
    disableSwitchAccountLink = _ref.disableSwitchAccountLink;
  var _resolveEnvironment = resolveEnvironment(identityEnvironment),
    baseUrl = _resolveEnvironment.baseUrl;
  var applicationParam = "application=".concat(encodeURIComponent(application));
  var continueParam = "continue=".concat(encodeURIComponent(continueUrl));
  var logOutContinueParam = logOutContinueUrl ? "continue=".concat(encodeURIComponent(logOutContinueUrl)) : continueParam;
  var manageProfileUrl = "".concat(baseUrl, "/manage-profile");
  var manageProfileLink = email ? "".concat(baseUrl, "/login?").concat(applicationParam, "&continue=").concat(encodeURIComponent(manageProfileUrl), "&prompt=none&login_hint=").concat(encodeURIComponent(email)) : manageProfileUrl;
  return {
    manageProfileLink: manageProfileLink,
    switchAccountLink: disableSwitchAccountLink ? undefined : "".concat(baseUrl, "/login?").concat(applicationParam, "&").concat(continueParam, "&prompt=select_account"),
    logOutLink: "".concat(baseUrl, "/logout?").concat(applicationParam, "&").concat(logOutContinueParam) + (disableSwitchAccountLink ? '' : '&prompt=none'),
    logInLink: isLoggedOut ? "".concat(baseUrl, "/login?").concat(applicationParam, "&").concat(continueParam) : undefined
  };
}